import { useRef } from 'react'
import styled from '@emotion/styled'

import { useHover } from 'src/components/app/utils/hooks/useHover'
import { IconButton } from 'src/ui-kit/iconButton/IconButton'
import TextTooltip from 'src/ui-kit/textTooltip/TextTooltip'

interface Props {
    size: string
    alt: string
    disabled: boolean
    src: string
    dataTestId?: string
    onClick: (event: React.MouseEvent<any, MouseEvent>) => void
    tooltip: string
    tooltipLeft: string
    tooltipTop: string
    shape?: 'circle' | 'square'
}

export function IconButtonHover({
    size,
    alt,
    disabled,
    src,
    dataTestId,
    onClick,
    tooltip,
    tooltipLeft,
    tooltipTop,
    shape,
}: Props) {
    const hoverRef = useRef<HTMLSpanElement>(null)
    const isHovering = useHover(hoverRef)

    return (
        <Wrapper $size={size}>
            <span ref={hoverRef}>
                <IconButton
                    size={size}
                    alt={alt}
                    disabled={disabled}
                    shape={shape}
                    src={src}
                    dataTestId={dataTestId}
                    onClick={onClick}
                />
            </span>
            {tooltip && isHovering && (
                <TextTooltip top={tooltipTop} left={tooltipLeft}>
                    {tooltip}
                </TextTooltip>
            )}
        </Wrapper>
    )
}

const Wrapper = styled.div<{ $size: string }>`
    position: relative;
    height: ${({ $size }) => $size};
    width: ${({ $size }) => $size};
`
